import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useContext } from "react";
import { LangContext } from "../../../Context/LangContext";
import BtnsApps from "../BtnsApps/BtnsApps";
import "./DownoadApp.css";
export default function DownloadApp() {
  const langCtx = useContext(LangContext);

  return (
    <div className="main-container" >
      <section className="download-app">
        <Row className="h-100 align-items-end p-5">
          <Col lg={7}>
            <div className="text-download-app">
              <h2> {text.TitleDownload[langCtx]} </h2>
              <p> {text.DesDownload[langCtx]}</p>
              <BtnsApps />
            </div>
          </Col>
          <Col lg={5}>
            <div className="img-downland-app">
              <img src="/images/download-screen1.png" alt="download-screen1" />
              <img src="/images/download-screen2.png" alt="download-screen2" />
            </div>
          </Col>
        </Row>
      </section>
    </div>
  );
}

const text = {
  TitleDownload: {
    ar: "قم بتحميل التطبيق",
    en: "Download the application",
  },
  DesDownload: {
    ar: "التطبيق متوفر الآن علي جميع منصات التحميل جوجل بلاي و آب استور !",
    en: "The application is now available on all download platforms, Google Play and App Store!",
  },
};
